import { Size, Token, } from "../../../core";
export class HurdleToken extends Token {
    constructor(id, position, color) {
        super(id, position, HurdleToken.size);
        this.color = color;
    }
    static isReadonlyInstance(token) {
        return token instanceof HurdleToken;
    }
}
HurdleToken.size = new Size(1.5, 1);
export function getHurdleTokenFactory(color) {
    return (id, position) => {
        return new HurdleToken(id, position, color);
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaHVyZGxlLXRva2VuLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3Nwb3J0cy9jb21tb24vZHJpbGwvaHVyZGxlLXRva2VuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFJTCxJQUFJLEVBQ0osS0FBSyxHQUVOLE1BQU0sZUFBZSxDQUFDO0FBRXZCLE1BQU0sT0FBTyxXQUFZLFNBQVEsS0FBSztJQUNwQyxZQUFZLEVBQVUsRUFBRSxRQUFrQixFQUFFLEtBQVk7UUFDdEQsS0FBSyxDQUFDLEVBQUUsRUFBRSxRQUFRLEVBQUUsV0FBVyxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ3RDLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO0lBQ3JCLENBQUM7SUFNRCxNQUFNLENBQUMsa0JBQWtCLENBQ3ZCLEtBQW9CO1FBRXBCLE9BQU8sS0FBSyxZQUFZLFdBQVcsQ0FBQztJQUN0QyxDQUFDOztBQU5lLGdCQUFJLEdBQUcsSUFBSSxJQUFJLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQyxDQUFDO0FBYTFDLE1BQU0sVUFBVSxxQkFBcUIsQ0FBQyxLQUFZO0lBQ2hELE9BQU8sQ0FBQyxFQUFVLEVBQUUsUUFBa0IsRUFBRSxFQUFFO1FBQ3hDLE9BQU8sSUFBSSxXQUFXLENBQUMsRUFBRSxFQUFFLFFBQVEsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM5QyxDQUFDLENBQUM7QUFDSixDQUFDIn0=